export default __webpack_public_path__ + "static/media/error-bg.19ab8a03.svg";